"use strict";

/**
 * Returns true if at least one of the provided class names is present in element
 *
 * @param {HTMLElement} element
 * @param {Array<string>} classNames
 * @return {boolean}
 */
function containsClassNames(element, classNames) {
  return [...element.classList].some((className) => -1 !== classNames.indexOf(className));
}

export default containsClassNames;
